var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttractivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#F6821F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1093 10.4707C12.4232 10.4707 9.27536 12.7634 8 15.9997C9.27536 19.2361 12.4232 21.5288 16.1093 21.5288C19.7953 21.5288 22.9431 19.2361 24.2185 15.9997C22.9431 12.7634 19.7953 10.4707 16.1093 10.4707ZM16.1093 19.6858C14.0746 19.6858 12.4232 18.0344 12.4232 15.9997C12.4232 13.9651 14.0746 12.3137 16.1093 12.3137C18.1439 12.3137 19.7953 13.9651 19.7953 15.9997C19.7953 18.0344 18.1439 19.6858 16.1093 19.6858ZM16.1093 13.7881C14.8855 13.7881 13.8976 14.776 13.8976 15.9997C13.8976 17.2235 14.8855 18.2114 16.1093 18.2114C17.333 18.2114 18.3209 17.2235 18.3209 15.9997C18.3209 14.776 17.333 13.7881 16.1093 13.7881Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttractivity);
export default __webpack_public_path__ + "static/media/attractivity.659e582c7b039ac096fc8cc3850cb483.svg";
export { ForwardRef as ReactComponent };